import React, { useState, useEffect,useContext } from "react";
import { Image } from "react-bootstrap";
import logo from "../assets/images/samagra-logo.png";
// import ecoclub from "../assets/images/ecoclub-logo.png";
import ecoclub from "../assets/images/Logo-2.png";
import MenuOpen from "../assets/images/bars.png";
import MOE from "../assets/images/schoolEdu-logo.png";
import { TbLogin2 } from "react-icons/tb";
import { House } from "phosphor-react";
import pmshreelogo from "../assets/images/pmshree-logo.png";
import AdminLoginModel from "./Authentication/AdminLoginModel";
import SchoolLoginModel from "./Authentication/SchoolLoginModel.jsx";
import FacultyLoginModel from "./Authentication/FacultyLoginModel.jsx";
import { jwtDecode } from 'jwt-decode';
import { FaRegBell } from "react-icons/fa6";
import axiosConn from "config/axiosConn";
import { Link, redirect, useNavigate } from "react-router-dom";
import { AppContext } from "../context";
import { BsInfoCircle } from "react-icons/bs";
import { PiTarget } from "react-icons/pi";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { TbSocial } from "react-icons/tb";
import {PiUsersThreeLight} from "react-icons/pi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
// import ecoclub from "../assets/images/ecoclub-logo.png";
import { userLoggedOut } from "../redux/auth/authSlice";

function Header() {
  const [show, setShow] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginRole, setLoginRole] = useState(null);
  const location = useLocation();
  const [role, setRole] = useState(null);
  const [isClick, setIsClick] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [udise_id, setUDISE] = useState('');
  const navigate = useNavigate();
  const [manu, setMenu] = useState(false);
  const { setSectionId } = useContext(AppContext);
  const userData = useSelector(state => state.auth.user);
  const dispatch=useDispatch();
  const [userName, setUserName] = useState("");

  useEffect(() => {
    // Check if a user is logged in by checking the token
    // const token = localStorage.getItem("token");
    console.log(userData, "userData2");
    if (!userData) {
      navigate("/");
      
    } else {
      if (userData.role === 1) {
        navigate("/Ekpedmaakenaam");
      }
      
      else if(userData.role===3){
        navigate("/faculty");
      }else if(userData.role===2){
        setIsLoggedIn(true);
        setLoginRole(userData.role);
        handleNotification({ collab_to_udise_id: userData.udise_id });
      }
    }
  }, [userData]);

  const handleNotification = async (postData) => {
    try {
      // let response = await axiosConn('post', 'get-collaboration', postData);
      // if (response.data.status === 'success') {
      //   setNotificationCount(response.data.result.count);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectLogin = (selectedRole) => {
    setRole(selectedRole);
    setIsClick(true);
  };

  const Logout = async () => {
    try {
      const makeLogout = await fetch(
        `https://ecoclubs.education.gov.in/api/logout`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (makeLogout.ok) {
       //  toast.success("Logout Successfully");
      }
    } catch (error) {
      toast.error("Logout Failed");
      console.log(error);
    }
    dispatch(userLoggedOut());
  };


  // useEffect(() => {
  //   const isLoginPage = location.pathname === "/admin/login";
  
  //   const schoolAllowedPaths = [
  //     "/school",
  //     "/school/createtheme",
  //     "/school/eventmanagement",
  //     "/school/eventlist",
        //  "/school/ecocalendar",
        //  "/school/event-assignment",
        //  "0/school/faculty-manage"
  //   ];
  
  //   const isAllowedPathForSchool = schoolAllowedPaths.includes(location.pathname);
  
  //   if (isLoginPage) {
  //     if (userData && userData.role === 2) {
  //       console.log("On login page with school user, redirecting...");
  //       navigate("/school", { replace: true });
  //     }
  //     return;
  //   }
  
  //   if (!userData || userData.role !== 2) {
  //     console.log("No school user data, redirecting to home.");
  //     navigate("/");
  //     return;
  //   }
  
  //   setIsLoggedIn(true);
  //   setUserName(userData.username);
  //   setLoginRole(userData.role);
  
  //   console.log("User has role 2 (school)");
  //   if (!isAllowedPathForSchool) {
  //     console.log("Redirecting school user to /school");
  //     navigate("/school");
  //   } else {
  //     console.log("Already on a valid school route, no redirect needed.");
  //   }
  // }, [userData, location.pathname, navigate]);
  

 const handleLogout = async() => {
   await Logout()
   setIsLoggedIn(false); // Update state
   navigate("/"); // Redirect to homepage
   ;
 };
  const handleHome = (e) => {
    e.preventDefault();
    navigate("/");
    
  }

  const handleClose = () => {
    setIsClick(false);
  };

  const handleHomeButton = () => {
    if (location.pathname === "/") {
      if (loginRole === 1) {
        navigate("/Ekpedmaakenaam");
      } else if (loginRole === 2) {
        navigate("/school");
      } else {
        navigate("/faculty");
      }
    } else {
      navigate("/");
    }
  }

  const handleNotificationFunction = async(postData) => {
    
    try {
      let response = await axiosConn('post', 'read-collaboration', postData);
      console.log(response,"response-----------------------------------------");
      if (response.data.status === 'success') {
        setNotificationCount(0);
        navigate('/school/notification');
      }
      
    } catch (error) {
      console.log(error);
    }
  };
  const scrollToSection = (sectionId) => {
    setSectionId(sectionId); // Store the section ID in context
    navigate('/'); // Navigate to eco-club
    // Add a timeout to allow the page to load before scrolling
    setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    }, 100); // Adjust the timeout as necessary
};
  return (
    <div className="mainTopDiv">
      <header>
        <div className="row py-1 animate__animated animate__fadeInDown">
        <div className="logo-sec col-6 col-lg-9 text-start d-flex justify-content-between align-items-center">
            <div  onClick={handleHome} title="" className="logo-eco">
              <Image src={ecoclub} alt="Logo" width="320px"  />
            </div>
            
            <Link
              to="https://www.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={MOE} alt="Logo" width={348} />
            </Link>
            <Link
              to="https://samagra.education.gov.in/"
              className="logo-dept"
              title=""
              target="_blank"
            >
              <Image src={logo} alt="Logo" width={240} />
            </Link>
            <Link
              to="https://pmshrischools.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={pmshreelogo} alt="Logo" width={158} />
            </Link>
            
          </div>

          <div className="menu-sec col-lg-3 col-md-5">
            <div className="login-signup-sec d-flex justify-content-end align-items-center">
              {!isLoggedIn ? (
                <>
                  <button title="Try for Free" className="btn-login-signup loginBtnnewhm" onClick={() => handleSelectLogin("school")}>
                    Login
                    <ul className="hmLoginList">
                      <li>
                        <Link onClick={() => handleSelectLogin("school")}>School Login</Link>
                      </li>
                      <li>
                        <Link onClick={() => handleSelectLogin("faculty")}>Faculty Login</Link>
                      </li>
                    </ul>
                  </button>
                  <button title="Try for Free" className="button green btn-login-signup loginBtnnewhm" onClick={() => handleSelectLogin("admin")}>
                    Super Admin
                  </button>
                </>
              ) : (
                <>
                  {loginRole === 2 && (
                    <div className="d-flex justify-content-start flex-column notify" style={{ marginRight: '2px' }}>
                      <Link className="mx-2" to="/school/notification" onClick={
                        (e) => {e.preventDefault();handleNotificationFunction({
                          collab_to_udise_id: udise_id
                        })}
                      }>
                        <FaRegBell size={25} color="#0d6efd" />
                        {notificationCount > 0 && <sup className="notification">{notificationCount}</sup>}
                      </Link>
                    </div>
                  )}
                  <button className="btn btn-primary homeBtnNewDiv" style={{ marginRight: '15px' }} onClick={() => handleHomeButton()}>Home</button>
                  <button className="btn btn-danger" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <nav className={manu ? "navbars mobile open animate__animated animate__fadeInUp":"navbars animate__animated animate__fadeInUp"}>
          <ul className="d-flex justify-content-center pl-5">
            <li>
              <a href="#" onClick={() => scrollToSection('themes')}>
                <span><House size={30} /></span> Themes
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('aboutEcoClubs')}>
              <BsInfoCircle size={22}/> About Eco Clubs for Mission LiFE
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('objectivesGoals')}>
              <PiTarget size={24}/> Objectives & Goals
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('publications')}>
              <MdOutlineLibraryBooks size={20}/> Publications
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('getSocial')}>
              <PiUsersThreeLight size={20}/> Let's Get Social
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('stakeholders')}>
              <TbSocial size={20}/>Stakeholders involved
              </a>
            </li>
          </ul>
        </nav>
      </header>

      {isClick && (
        <>
          {role === "school" && <SchoolLoginModel handleViewexit={handleClose} />}
          {role === "faculty" && <FacultyLoginModel handleViewexit={handleClose} />}
          {role === "admin" && <AdminLoginModel handleViewexit={handleClose} />}
        </>
      )}
    </div>
  );
}

export default Header;
